import $ from 'jquery'
export default {
  name: 'create-visite-modal',
  components: {},
  props: [],
  data () {
    return {
      latest_vm: null,
      loading: false,
      selectedSociete: null,
      visite: {
        societe_id: null,
        date_debut: null,
        date_fin: null,
        sous_categorie_id: null
      }
      

    }
  },
  computed: {
    societes(){
      // let full_societes = [];
      let full_societes = this.$store.getters["societes"] 
      let societes =[]
      full_societes.forEach( element =>{
        if(element.travailleursCount > 0){
          societes.push(element)
        }
        
      })
      return societes;
    },
    subCategory(){
      return this.$store.getters["selectedSousCategoryVM"]
    },

  },
  mounted () {
    this.$store.dispatch("getSocietes")
  },
  methods: {
    createVisiteMedicale: async function(){
      const isValid = await this.$refs.visiteCreate.validate();
      console.log(isValid);
      if(!isValid){
        return ;
      } else {
        this.loading = true
        

      this.visite.societe_id = this.selectedSociete.id
      this.visite.sous_categorie_id = this.subCategory.id
      this.$store.dispatch("programVisiteMedicale",this.visite).then(
        async() =>{
        this.loading = false,
        this.selectedSociete = null,
        this.$refs.visiteCreate.reset()
        $('.modal').modal('hide'),
        this.successCreateVM(),
        
        await this.$store.dispatch("getSocieteCurrentVisiteMedicale",this.visite.societe_id).then(
            response =>{
              let data = {visite_medicale_id: response.id}
              this.$store.dispatch("initVisitesMedicalesProgrammation",{societe_id: this.visite.societe_id, data:data}).then(
                () => {
                  this.visite.date_debut = null
                  this.visite.date_fin = null
                  
                  this.$router.push({name:'Parametrage_Societe',params:{id:this.visite.societe_id,params:'parametrage'}})
                  
                  
                }
              )      
            }
        )
         
          
          
        
        }
      )
      }
      
    },
    successCreateVM: function() {
      this.$toasted.show('la visite a été programmé avec succès', {
          duration: 3000,
          action: [{
              text: 'X',
              onClick: (e, toastObject) => {
                  toastObject.goAway(0);
              }
          }],
          theme: 'toasted-primary',
          type: 'success',
          position: 'top-center'

      })
  }
    
  }
}


